export interface IApiResponse<T> {
  status?: string
  data?: T
  detail?: string
}

export interface IErrorResponse {
  message?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export const s3sha256base = 'https://s3-us-east-2.amazonaws.com/polimorphic-sha256/'
export const s3securebase = 'https://polimorphic-secure'
